import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConstructionCompaniesListComponent } from './components/construction-companies-list/construction-companies-list.component';
import { ConstructionCompanyDetailComponent } from './components/construction-company-detail/construction-company-detail.component';
import { ConstructionCompanyProjectComponent } from './components/construction-company-project/construction-company-project.component';
import { RegisterConstructionProjectComponent } from './components/register-construction-project/register-construction-project.component';
import { IsAuthGuard } from '../../guards/is-auth.guard';
import { IsVerifiedGuard } from 'src/app/guards/is-verified.guard';
import { RegisterProyectTypesComponent } from './components/register-proyect-types/register-proyect-types.component';
import { ConstructionCompanyHomeComponent } from './components/construction-company-home/construction-company-home.component';
import { ConstructionProjectHomeComponent } from './components/construction-project-home/construction-project-home.component';
import { AllConstructionProjectsComponent } from './components/all-construction-projects/all-construction-projects.component';

const routes: Routes = [
//    { path: '', redirectTo: 'destacadas' },
    { path: '', component: ConstructionCompaniesListComponent },
    { path: 'todos-los-proyectos', component: AllConstructionProjectsComponent},
    { path: ':slug', component: ConstructionCompanyHomeComponent },
    { path: ':slug/proyecto/register', component: RegisterProyectTypesComponent, canActivate: [IsAuthGuard, IsVerifiedGuard] },
    { path: ':slug/proyecto/:projectSlug/inmuebles/register', component: RegisterConstructionProjectComponent, canActivate: [IsAuthGuard, IsVerifiedGuard] },
    { path: ':slug/proyecto/:projectSlug', component: ConstructionProjectHomeComponent},
    { path: ':slug/proyecto/:projectSlug/inmueble/:inmuebleSlug', component: ConstructionCompanyProjectComponent  },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ConstructionCompaniesRoutingModule { }
